import React, { useEffect, useState } from "react";
import { RegisterTag, Logo } from "assets/svg";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import {
  cleanDataRegister,
  fetchSendMailRegisterBuyer,
} from "reducers/registerSlice";
import { message } from "antd";

const BuyerRegister: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [emailRegister, setEmailRegister] = useState("");
  const { registerBuyerData, errorBuyer } = useSelector(
    (state: RootState) => state.register,
  );

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (emailRegister.trim()) {
      dispatch(fetchSendMailRegisterBuyer(emailRegister));
    }
  };

  useEffect(() => {
    if (errorBuyer) {
      message.error(errorBuyer.response.data.message);
    }

    if (registerBuyerData) {
      navigate("/buyer/sent-mail");
    }

    dispatch(cleanDataRegister());
  }, [registerBuyerData, errorBuyer]);

  return (
    <main className="bg--blur box">
      <div
        className="w-full mt-[60px] relative rounded-[20px] border-[8px] border-white bg-primary-light shadow-[0_0_15px_0_rgba(0,0,0,0.05)] flex flex-col items-center justify-center py-[52px] px-[22px]
        sm:max-w-[580px] sm:py-[72px] sm:px-[62px]"
      >
        <div className="absolute z-[2] top-[-80px] sm:top-[-39px] right-[12px]">
          <RegisterTag className="w-[115px] sm:w-[154px] h-[129px] sm:h-[168px]"></RegisterTag>
          <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-[22px] sm:text-[28px] font-bold leading-[160%] text-white">
            Buyer
          </span>
        </div>
        <Logo
          className="flex justify-center items-center w-[200px] h-[81px] aspect-[1/1] mb-[30px]
             sm:w-[300px] sm:h-[121px] sm:mb-[40px]"
        />
        <h2
          className="text-[22px] not-italic font-bold text-primary mb-[15px]
        sm:text-[28px]"
        >
          新規ユーザー登録
        </h2>
        <p className="text-[15px] font-normal leading-[160%] text-center mb-[30px] sm:text-[16px]">
          サービスを利用するには <br className="sm:hidden" />
          メールアドレスの確認が必要です。
          <br />
          下記のメールアドレス宛に <br className="sm:hidden" />
          確認メールを送信します。
          <br />
        </p>

        <form
          onSubmit={handleSubmit}
          className="w-full flex flex-col items-center"
        >
          <label className="text-[22px] not-italic font-bold text-primary mb-[5px] sm:text-[18px]">
            メールアドレス
          </label>
          <input
            onChange={(e) => setEmailRegister(e.target.value)}
            type="email"
            className="w-full h-[50px] px-[20px] rounded-[6px] mb-[30px] sm:mb-[40px] text-[18px]"
            placeholder="sample@example.com"
            required
          />
          <button
            type="submit"
            className="w-full bg-primary text-white py-2 rounded-[6px] mb-[15px] sm:max-w-[340px] sm:text-[18px] sm:mb-[20px]"
          >
            確認メールを送信
          </button>
        </form>
        <p className="text-black mb-[20px] sm:text-[14px]">
          すでにアカウントをお持ちの方は
          <Link to={"/"} className="underline">
            ログイン
          </Link>
        </p>
      </div>
    </main>
  );
};

export default BuyerRegister;
